<template>
  <div class="accountHeader">
    <h1 v-if="breadcrumbs.length === 1" class="accountHeader_single-text">
      {{ breadcrumbs[0].text }}
    </h1>
    <v-breadcrumbs v-else :items="breadcrumbs">
      <template #divider>
        <v-icon size="22"> mdi-chevron-right </v-icon>
      </template>
      <template #item="{ item }">
        <v-breadcrumbs-item
          :to="item.to"
          :disabled="item.disabled"
          :link="item.link"
          class="accountHeader_breadcrumbs-item"
          :class="{ ['accountHeader_breadcrumbs-item--active']: item.active }"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <span class="accountHeader_subtitle">{{ desc }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'AccountHeader',
  data() {
    return {
      breadcrumbs: [],
      desc: '',
    };
  },
  computed: {
    ...mapState({
      helpCategories: (state) => state.help.categories,
    }),
    activeSetting() {
      return this.$route.params.parent;
    },
  },
  watch: {
    $route(to) {
      this.setBreadcrumbs(to);
    },
  },
  mounted() {
    this.setBreadcrumbs(this.$route);
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    setBreadcrumbs({ name, params, query }) {
      let breadcrumbs = [];
      if (name === 'account-email') {
        breadcrumbs.push({
          text: 'メールアドレス変更',
          disabled: false,
          to: { name: 'account-email' },
          active: true,
          link: true,
        });
        this.desc = 'ログイン時のメールアドレス変更';
      }
      if (name === 'account-name') {
        breadcrumbs.push({
          text: 'ユーザー名の設定',
          disabled: false,
          to: { name: 'account-name' },
          active: true,
          link: true,
        });
        this.desc = 'ユーザー名の変更';
      }
      if (name === 'account-org') {
        breadcrumbs.push({
          text: '組織の切り替え',
          disabled: false,
          to: { name: 'account-org' },
          active: true,
          link: true,
        });
        this.desc = 'ログインしている組織の切り替え';
      }
      if (name === 'account-password') {
        breadcrumbs.push({
          text: 'パスワード設定',
          disabled: false,
          to: { name: 'account-password' },
          active: true,
          link: true,
        });
        this.desc = 'SECOM Sights IDパスワードの変更';
      }

      if (name.startsWith('account-mfa')) {
        breadcrumbs.push({
          text: 'セキュリティ設定',
          disabled: false,
          to: { name: 'account-mfa' },
          link: true,
        });
        this.desc = '多要素認証によるセキュリティ設定';
        if (name === 'account-mfa-sms') {
          breadcrumbs.push({
            text: '電話番号に認証コードを送信する',
          });
          this.desc = '認証コードを送信する電話番号を設定';
        } else if (name === 'account-mfa-totp') {
          breadcrumbs.push({
            text: 'Authenticatorアプリを使用する',
          });
          this.desc = '認証コードを送信するAuthenticatorアプリを設定';
        } else if (name === 'account-mfa-nomfa') {
          breadcrumbs.push({
            text: '多要素認証を使用しない',
          });
          this.desc = 'ログイン時の多要素認証を解除';
        }
      }
      this.breadcrumbs = breadcrumbs;
    },
  },
};
</script>

<style lang="scss">
.accountHeader {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  color: var(--text-color);
  max-width: 966px;

  &_single-text {
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
    margin: 5px 0;
  }
  &_breadcrumbs-item {
    &--active {
      a {
        font-size: 20px !important;
        font-weight: bold !important;
        color: #4b4b4b !important;
      }
    }
    a {
      &.v-breadcrumbs__item {
        line-height: 2;
      }
    }
  }
  &_text {
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
  }
  &_type {
    color: var(--warning-color-lighten1);
    font-size: 12px;
    font-weight: 600;
  }
  .v-breadcrumbs__divider {
    padding: 0 5px !important;
    .theme--light.v-icon {
      color: #989898;
    }
  }
  .v-breadcrumbs {
    padding: 0;
  }
  .theme--light.v-breadcrumbs .v-breadcrumbs__divider,
  .theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled {
    color: #4b4b4b;
    font-weight: normal;
    pointer-events: all;
    cursor: pointer;
  }
  .v-breadcrumbs__item {
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
    font-size: 20px;
  }
  &_subtitle {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
  }
}
</style>
